import { usePermissions } from 'commons/customHooks'
import i18n from 'commons/libs/i18n'

import { hasPermission } from '../helpers'
import { MenuItemNode } from '../MenuItemNode'
import type { MenuSection } from '../MenuSidebar'
import * as S from '../styles'

type MenuProps = {
  menu: MenuSection[]
  collapsed: boolean
  openItems: string[]
  onSubmenuToggle: (itemId: string, level: number) => void
}

export const Menu = ({ menu, collapsed, openItems, onSubmenuToggle }: MenuProps) => {
  const { verifyPermission } = usePermissions()

  return (
    <S.Menu collapsed={collapsed}>
      {menu.map(({ titleKey, menuLists }, sectionIndex) => {
        if (!hasPermission(menuLists, verifyPermission)) return

        return (
          <div key={`${titleKey ?? 'menu'}-${sectionIndex}`}>
            {!!titleKey && <S.MenuTitle collapsed={collapsed}>{i18n.t(titleKey)}</S.MenuTitle>}

            <S.MenuContent collapsed={collapsed}>
              {menuLists.map((item, itemIndex) => {
                if (!hasPermission([item], verifyPermission)) return

                return (
                  <MenuItemNode
                    collapsed={collapsed}
                    item={item}
                    key={`${item.itemId}-${itemIndex}`}
                    level={0}
                    onSubmenuToggle={onSubmenuToggle}
                    openItems={openItems}
                  />
                )
              })}
            </S.MenuContent>
          </div>
        )
      })}
    </S.Menu>
  )
}
